import { useEffect } from 'react';

const CATS = ['Schele', 'Schele', 'Fișă 112C', 'Fișă 120C', 'Schele', 'Schele', 'Fișă 110C',
  'Acces', 'Acces', 'Acces', 'Acces', 'Pisică', 'Pisică', 'Acces', 'Pisică', 'Pisică',
  'Acces', 'Acces', 'Acces', 'Acces', 'Acces', 'Acces', 'Acces', 'Acces', 'Acces', 'Acces',
  'Acces', 'Acces', 'Acces', 'Acces', 'Acces', 'Acces'];

export default function LotGallery() {
  useEffect(() => {
    document.title = 'EGEA · Lot imagini (review)';
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', color: '#0f172a', fontFamily: 'IBM Plex Sans, Arial, sans-serif' }} data-testid="lot-gallery-page">
      <header style={{ background: '#fff', borderBottom: '2px solid #e2e8f0', padding: '16px 20px', position: 'sticky', top: 0, zIndex: 10 }}>
        <h1 style={{ margin: 0, fontSize: 20, letterSpacing: '.5px' }}>EGEA — Lot imagini pentru clasificare</h1>
        <p style={{ margin: '6px 0 0', fontSize: 13, color: '#64748b' }}>32 imagini, numerotate 1–32. Spune-mi numerele și categoria unde le adaug.</p>
      </header>
      <div style={{ padding: '12px 20px', fontSize: 13, color: '#64748b', lineHeight: 1.6 }}>
        Sugestie automată (o poți ignora): Schele = turnuri schelă · Fișă = document tehnic · Pisică = scară cu cușcă · Acces = scară/platformă metalică containere.
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 12, padding: '12px 20px 60px' }} data-testid="lot-grid">
        {CATS.map((cat, i) => {
          const n = i + 1;
          const src = `/lot/${n}.jpg`;
          return (
            <div key={n} style={{ border: '1px solid #e2e8f0', background: '#fff', borderRadius: 4, overflow: 'hidden' }} data-testid={`lot-item-${n}`}>
              <div style={{ position: 'relative', aspectRatio: '1 / 1', background: '#eef2f7' }}>
                <span style={{ position: 'absolute', top: 6, left: 6, background: '#f5a524', color: '#0f172a', fontWeight: 700, fontSize: 15, minWidth: 30, textAlign: 'center', padding: '3px 7px', borderRadius: 3 }}>{n}</span>
                <a href={src} target="_blank" rel="noreferrer">
                  <img src={src} alt={`Imagine ${n}`} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                </a>
              </div>
              <div style={{ padding: 8, fontSize: 12 }}>
                <b style={{ display: 'block', fontSize: 11, textTransform: 'uppercase', letterSpacing: '.4px', color: '#64748b' }}>#{n}</b>
                {cat}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
